/**
 * Formats a number to a shortened string with K for thousands.
 * @param {number} num - The number to format
 * @returns {string} - Formatted number string (e.g., "1.2K", "100")
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined) return "0";

  const absNum = Math.abs(num);

  // Format for numbers >= 1100 (1.11K)
  if (absNum >= 1100) {
    return (num / 1000).toFixed(2).replace(/\.0+$/, "") + "K";
  }

  // Return as is for smaller numbers
  return num.toFixed(2);
};
